/** Parse "H:MM:SS" or "HH:MM:SS" into total seconds. Returns null if invalid. */
export function parseHmsToSeconds(raw) {
  const s = String(raw || '').trim();
  if (!s) return null;
  const parts = s.split(':').map((p) => p.trim());
  if (parts.length !== 3) return null;
  const h = parseInt(parts[0], 10);
  const m = parseInt(parts[1], 10);
  const sec = parseInt(parts[2], 10);
  if (![h, m, sec].every((n) => Number.isFinite(n) && n >= 0)) return null;
  if (m > 59 || sec > 59) return null;
  if (h > 23) return null;
  const total = h * 3600 + m * 60 + sec;
  return total > 0 ? total : null;
}

export function formatSecondsToHms(totalSeconds) {
  const s = Math.max(0, Math.floor(totalSeconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
}
